import React from 'react';

interface ScoreProps{
  score: string[];
}

export class Score extends React.Component<ScoreProps>{
  generateScoreNodes(): React.ReactNode[]{
    const nodes: React.ReactNode[] = [];
    const { score } = this.props;
    score.forEach( (color, index) => {
      nodes.push(
        <div  key={index} 
              className='flex-1 rounded-sm borderSolid aspect-square border-barBackground'
              style={{
                backgroundColor: color === 'Red' ? 'transparent' : color,
                border: color === 'Red' ? '2px dashed' : '0px none'
              }}></div>
      )
    })

    return nodes;
  }

  render(): React.ReactNode{
    return (
      <div className = "grid h-full grid-flow-row grid-cols-2 grid-rows-2 gap-0.5 min-h-[32px] aspect-square">
        {this.generateScoreNodes()}
      </div>
    )
  }
}
